import { QueryClient } from '@mint-lib/query-client';

export const queryClient = new QueryClient();

export enum QueryKey {
  UserProfile = 'UserProfile',
  UserRole = 'UserRole',
  UsersData = 'UsersData',
  AgencyClients = 'AgencyClients',
}
